angular.module('tgaAdmin').directive('stWatchRangeChange', () => ({
  require: 'stTable',
  restrict: 'A',
  link: (scope, elem, attr, ctrl) => {
    scope.$on('updatedDatepickerRange', () => {
      const tableState = ctrl.tableState();
      tableState.pagination.start = 0;
      ctrl.pipe(tableState);
    });
  },
}));
